var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader",class:[ 'button_' + _vm.type ]})
}
var staticRenderFns = []

export { render, staticRenderFns }